import { render, staticRenderFns } from "./EventsFilled.vue?vue&type=template&id=35cfb5a7"
import script from "./EventsFilled.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsFilled.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports